import { useQuery } from "@tanstack/react-query";
import {
  ALL_PROFILES_QUERY_KEY,
  USERS_STALE_TIME,
} from "@/lib/users-cache";
import { userService } from "@/services/UserService";

export { ALL_PROFILES_QUERY_KEY, USERS_STALE_TIME } from "@/lib/users-cache";

export const useAllProfiles = () =>
  useQuery({
    queryKey: ALL_PROFILES_QUERY_KEY,
    queryFn: () => userService.fetchAllProfiles(),
    staleTime: USERS_STALE_TIME,
  });
